import Vue from 'vue'
/**
 * Change year report
 * @author Luis Rodriguez
 * @param id Affected id
 * @param changeYear New year
 * @return {Object}
 */
const changeYearReport = (id, changeYear) =>
  Vue.$http.put(`sinisters/affected/${id}/new_year/`, changeYear)
    .then()
    .catch(err => { throw err })

export default changeYearReport



// WEBPACK FOOTER //
// ./src/services/sinister/changeYearReport.js